export enum ObjectFieldStatus {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  INACCESSIBLE = 'INACCESSIBLE',
  INCONSISTENT = 'INCONSISTENT',
  DELETED = 'DELETED',
  DISABLED = 'DISABLED'
}

export interface ObjectFieldCellRawDefinition<T = unknown> {
  value: T;
  helper_text: string;
  is_editable: boolean;
  reason: string;
}

export interface ObjectFieldRawCells {
  [key: string]: ObjectFieldCellRawDefinition;
}

export interface ObjectFieldsRawData {
  fields: { key: string; value: ObjectFieldRawCells }[];
  integration_id: number;
  load_mode: unknown;
  object_id: string;
  object_name: string;
  destination_table_name: string;
}

export interface ObjectFieldCellDefinition<T = unknown> {
  value: T;
  helperText: string;
  isEditable: boolean;
  statusReason: string;
}

export interface ObjectFieldCells {
  [key: string]: ObjectFieldCellDefinition;
}

export interface ObjectField {
  cells: ObjectFieldCells;
  fieldName: string;
  status: ObjectFieldCellDefinition<ObjectFieldStatus>;
  isConfigurable: boolean;
}

export interface FieldsSelectionUpdatesPayload {
  fields: {
    key: string;
    value: {
      status: ObjectFieldStatus;
      [key: string]: unknown;
    };
  }[];
  config: {
    load_mode: string;
  };
}
